// -----------------------------------------------------------------------------
// AIDAS Platform — useAuth.ts
// -----------------------------------------------------------------------------

import { createContext, useContext } from "react";

export interface User {
    name: string;
    email: string;
    id: string;
    roleId: string;
    role: string;
    tenantId?: string;
    tenantTimezone?: string;
    partnerId?: string;
    tenant?: any;
    forceReauth?: boolean;
    gracePeriodExpiresAt?: number;
    preferences?: any;
    permissions?: string[];
    profile_pic?: string | null;
    contact_number?: string | null;
    company?: string | null;
    location?: string | null;
    state?: string | null;
    country?: string | null;
}

export interface AuthContextProps {
    user: User | null;
    token: string | null;
    sid: string | null;
    pwdExp: number | null;
    loading: boolean;
    login: (username: string, password: string) => Promise<void>;
    requestMagicLink: (email: string) => Promise<void>;
    loginWithMagicToken: (token: string) => Promise<void>;
    verifyMfa: (mfaSessionToken: string, otpCode: string) => Promise<void>;
    resendMfa: (mfaSessionToken: string) => Promise<void>; // <== Added Resend MFA
    loginWithToken: (token: string, sessionSid?: string, skipRedirect?: boolean) => Promise<void>;
    logout: () => void;
    refreshUser: () => Promise<void>;
    passwordPolicy: any | null;
    branding: any | null;
    lastActivity: number;
    resetInactivity: () => void;
    timezone: string;
    countryCode: string;
    countryName: string;
}

export const AuthContext = createContext<AuthContextProps | undefined>(undefined);

export const useAuth = (): AuthContextProps => {
    const context = useContext(AuthContext);
    if (!context) throw new Error("useAuth must be used within an AuthProvider");
    return context;
};
